import * as React from "react";
import BajaContainer from "../containers/baja-container";

export default function BajaPage() {
  return <BajaContainer></BajaContainer>;
}
